import React, { useState } from "react";
import { HTTP } from "../api/http-common";
import { isValidEmail } from '../component/common';
import {  Mail, Phone, } from "lucide-react";
import Swal from 'sweetalert2'
import ReCAPTCHA from "react-google-recaptcha";


function ContactUs() {
  
  const [captchaValue, setCaptchaValue] = useState(null);
  
  
  const [firstName, setFirstName] = useState("");
  const [firstNameError, setFirstNameError] = useState("");

  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");//

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [reason, setReason] = useState("");
  const [reasonError, setReasonError] = useState("");

  const resetValidationErrors = () => {
    setFirstNameError('');
    setEmailError('');
    setPhoneNumberError('');
    setReasonError('');
  };

  const resetForm = () => {
    setFirstName('');
    setEmail('');
    setPhoneNumber('');
    setReason('');
  };


  const validateField = () => {

    // alert("Form submitted successfully!");
    resetValidationErrors();

    let checked = true;
    if (firstName === '') {
      setFirstNameError('Please enter name');
      if (checked) {
        checked = false;
      }
    } else if (firstName.length < 3) {
      setFirstNameError("Please enter minimum 3 characters");
      if (checked) {
        checked = false;
      }
    } else if (firstName.length > 100) {
      setFirstNameError("Max character limit is 100");
      if (checked) {
        checked = false;
      }
    }

    if (phoneNumber === '') {
      setPhoneNumberError('Please enter phone number');
      if (checked) {
        checked = false;
      }
    } else if (phoneNumber.length > 100) {
      setPhoneNumberError("Max character limit is 10");
      if (checked) {
        checked = false;
      }
    }

    if (reason === '') {
      setReasonError('Please enter reason');
      if (checked) {
        checked = false;
      }
    } else if (reason.length < 10) {
      setReasonError("Min 10 character required");
      if (checked) {
        checked = false;
      }
    }
    else if (reason.length > 1000) {
      setReasonError("Max character limit is 1000");
      if (checked) {
        checked = false;
      }
    }



    if (email === '') {
      setEmailError('Please enter email address');
      if (checked) {
        checked = false;
      }
    }
    else if (!isValidEmail(email)) {
      setEmailError('Invalid email.');
      if (checked) {
        checked = false;
      }
    } else if (email.length > 100) {
      setEmailError("Max character limit is 100");
      if (checked) {
        checked = false;
      }
    }



    return checked;
  };
  const handleSubmit = async () => {
    if (validateField()) {
      if (!captchaValue) {
        alert("Please verify reCAPTCHA");
        return;
      }
      try {
        let fields = {
          name: firstName,
          email: email,
          reason: reason,
          contact_no: phoneNumber

        };

        await HTTP.post(
          "/user/contactus",
          fields,
          // config
        )
          .then(async (response) => {
            if (response.status === 200) {
              Swal.fire({
                title: "We will get back to you soon!",
                // text: "We will get back to you soon!",
                icon: "success"
              });
              resetValidationErrors();
              resetForm();
              // navigate('/verify');
            }
          })
          .catch((error) => {
            if (error.response.status === 406) {
              resetValidationErrors();
              // setPasswordError(error.response.data.detail);
            }
            if (error.response.status === 400) {
              Swal.fire({
                title: 'Error!',
                text: 'You are already registered!',
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }
            // setError(error);
            // setRerenderFlag(true);
            // loadAaMasterData();
            // resetValidationErrors();
          });

        // setIsLoading(false);
      } catch (error) {
        // setError(error);
        // setRerenderFlag(true);
        // setIsLoading(false);
      }
    }
  };
  return (
    <>
      <div className="contact-page" >
        <div className="container md:py-10 py-4 md:px-0 px-2">
          <div className="flex flex-wrap items-center">
            <div className="w-[50%] px-[15px] contact-us-section">
              <h1 className="font-bold text-2xl md:text-[40px] mb-4 md:mb-[20px]"  >
                Contact Us
              </h1>
              <div >
                <p  >
                  <span className="event-time-detail" >
                    Get in touch with Family Fun Arizona! We’re happy to answer your questions regarding upcoming events, becoming a Preferred Business Partner, the Family Fun Club Membership, Vendor/Sponsorship Opportunities during our Festivals and more!
                  </span>
                  <div className="flex event-time-detail md:flex-row flex-col items-center py-[15px] flex-wrap">
                    <div className="w-full text-center md:w-auto">
                    <p className="mb-2 md:mb-0 ">Family Fun AZ LLC :</p>
                    </div>
                    <div className="flex aling-items-center mx-2">
                      <span className="small-icons-wrapper">
                        <Phone size={16} strokeWidth={1.25} />
                      </span>

                      <a className="contact-source" href="tel:+1 480-291-4471">480-291-4471</a>

                    </div>

                    <div className="flex aling-items-center">
                      <span className="small-icons-wrapper" >
                        <Mail size={16} strokeWidth={1.25} />
                      </span>
                      <a className="contact-source" href="mailto:bmcennis@familyfunaz.com,"> bmcennis@familyfunaz.com</a>
                    </div>
                  </div>
                  
                </p>
              </div>
            </div>
            <div className="w-[50%] px-[15px] contact-us-section">
                  <div className="contact-us-illustrator" >
                    <img src="./assets/minified.svg" alt="contact-us illustrator" />
                  </div>
            </div>
            {/* <div className="w-[40%] px-[15px] contact-us-section contact-us-form">
              <div
                className="rounded-xl border bg-card text-card-foreground w-full p-6 md:p-8 shadow-sm max-w-[650px] min-h-[450px]"
              // style={{ maxHeight: "580px", height: "100%", overflow: "scroll" }}
              >

                <div className="flex flex-col gap-8">
                  {/* First Name 
                  <div className="relative space-y-1">
                    <div className="relative space-y-1">
                      <input
                        className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                        placeholder=" "
                        name="name"
                        value={firstName}
                        onChange={(e) => {
                          setFirstName(e.target.value);
                        }}
                      />
                    </div>
                    <label
                      className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500"
                    >
                      Name
                    </label>
                    {firstNameError && <span className="text-sm text-red-500">{firstNameError}</span>}
                  </div>
                  {/* Email 
                  <div className="relative space-y-1">
                    <div className="relative space-y-1">
                      <input
                        type="email"
                        className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                        placeholder=" "
                        name="email"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                    </div>
                    <label
                      className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500"
                    >
                      Email
                    </label>
                    {emailError && <span className="text-sm text-red-500">{emailError}</span>}
                  </div>
                  {/* Phone Number 
                  <div className="relative space-y-1">
                    <div className="relative space-y-1">
                      <input
                        className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                        placeholder=" "
                        name="phoneNumber"
                        value={phoneNumber}
                        onChange={(e) => {
                          setPhoneNumber(e.target.value);
                        }}
                      />
                    </div>
                    <label
                      className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500"
                    >
                      Phone Number
                    </label>
                    {phoneNumberError && <span className="text-sm text-red-500">{phoneNumberError}</span>}
                  </div>

                  {/* Phone Number 
                  <div className="relative space-y-1">
                    <div className="relative space-y-1">
                      <textarea
                        rows="4"
                        className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer  px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                        placeholder=" "
                        name="reason"
                        value={reason}
                        onChange={(e) => {
                          setReason(e.target.value);
                        }}
                      />
                    </div>
                    <label
                      className="absolute left-0 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-2.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-500"
                    >
                      Reason
                    </label>
                    {reasonError && <span className="text-sm text-red-500">{reasonError}</span>}
                  </div>

                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                    onChange={(value) => setCaptchaValue(value)}
                  />
                  {/* Submit Button 
                  <button
                    className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 shadow px-4 py-2 w-full h-8 bg-[#6C38FF] hover:bg-[#5b2ee6] text-white rounded-lg mt-2 login-page-button-wrapper"
                    type="submit"
                    onClick={handleSubmit}
                  >
                    <Phone size={20} />
                    
                    <span className="text-lg font-semibold"> Contact Us </span>
                  </button>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>


    </>
  )
}

export default ContactUs